const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0062FF"
    },
    d: "M394.69,393.73h-54.76v-54.76h54.76V393.73z M348.19,385.47h38.23v-38.23h-38.23V385.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 357.49,
    y: 356.54,
    style: {
      fill: "#0062FF"
    },
    width: 19.63,
    height: 19.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0062FF"
    },
    d: "M158.97,393.73h-54.76v-54.76h54.76V393.73z M112.48,385.47h38.23v-38.23h-38.23L112.48,385.47 L112.48,385.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.78,
    y: 356.54,
    style: {
      fill: "#0062FF"
    },
    width: 19.63,
    height: 19.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0062FF"
    },
    d: "M158.97,158.02h-54.76v-54.76h54.76V158.02z M112.48,149.75h38.23v-38.23h-38.23L112.48,149.75 L112.48,149.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.78,
    y: 120.82,
    style: {
      fill: "#0062FF"
    },
    width: 19.63,
    height: 19.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 121.41,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 139.57,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 157.72,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 157.72,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.98,
    y: 175.88,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.29,
    y: 175.88,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 194.03,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 212.19,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.76,
    y: 212.19,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 230.34,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.21,
    y: 230.34,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 194.03,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.99,
    y: 212.18,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 212.19,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 248.5,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 230.34,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.53,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.38,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.38,
    y: 302.96,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.22,
    y: 284.81,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 230.34,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.29,
    y: 248.5,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.29,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 284.81,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 321.12,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 339.27,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 357.43,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 357.43,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.76,
    y: 375.58,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.99,
    y: 248.49,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.67,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 302.96,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.52,
    y: 284.81,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 302.96,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.21,
    y: 284.8,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 157.73,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.52,
    y: 175.88,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 175.88,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 212.19,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.21,
    y: 194.03,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.52,
    y: 212.19,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 230.34,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.21,
    y: 230.34,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.21,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.07,
    y: 103.26,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.22,
    y: 121.41,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.22,
    y: 139.57,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.53,
    y: 139.57,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.38,
    y: 157.72,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.92,
    y: 121.42,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.76,
    y: 139.57,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 139.57,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.6,
    y: 175.88,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 157.73,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 103.26,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.3,
    y: 103.26,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.29,
    y: 139.57,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 121.42,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 358.38,
    y: 230.34,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.23,
    y: 248.5,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.07,
    y: 248.5,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.07,
    y: 284.8,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 266.65,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 340.22,
    y: 212.19,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.07,
    y: 194.04,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.54,
    y: 212.19,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.38,
    y: 194.04,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.07,
    y: 175.88,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.76,
    y: 175.88,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 157.73,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 357.43,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.3,
    y: 375.58,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 375.58,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.76,
    y: 321.11,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.61,
    y: 302.96,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.07,
    y: 321.11,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.92,
    y: 302.96,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.3,
    y: 339.27,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 321.12,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 302.97,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 302.97,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.99,
    y: 284.81,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.99,
    y: 357.42,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.99,
    y: 339.27,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.67,
    y: 339.27,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 321.12,
    style: {
      fill: "#0062FF"
    },
    width: 18.15,
    height: 18.15
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#0062FF",
      strokeWidth: 20.2336,
      strokeMiterlimit: 10
    },
    points: "62.55,179.45 62.55,60.4  181.59,60.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#0062FF",
      strokeWidth: 20.2336,
      strokeMiterlimit: 10
    },
    points: "436.35,179.45 436.35,60.4  317.3,60.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#0062FF",
      strokeWidth: 20.2336,
      strokeMiterlimit: 10
    },
    points: "436.35,327.07 436.35,446.12  317.3,446.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#0062FF",
      strokeWidth: 20.2336,
      strokeMiterlimit: 10
    },
    points: "62.55,327.07 62.55,446.12  181.59,446.12  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.8d659870dd835b006e0d501e3f4a5ca3.svg";
export { ForwardRef as ReactComponent };